/**
 * Reglas de validación y constantes para formularios
 * Centraliza todas las expresiones regulares, límites y mensajes de error
 */

// ============================================================================
// EXPRESIONES REGULARES
// ============================================================================

/** Permite solo letras (mayúsculas/minúsculas), acentos, ñ y espacios */
export const REGEX_SOLO_LETRAS = /^[A-ZÁÉÍÓÚÜÑa-záéíóúüñ\s]+$/;

/** Valida que el teléfono tenga exactamente 10 dígitos */
export const REGEX_TELEFONO_10_DIGITOS = /^\d{10}$/;

/** Detecta números repetitivos (ej: 1111111111, 2222222222) */
export const REGEX_NUMERO_REPETITIVO = /^(\d)\1{9}$/;

/** Detecta solo ceros */
export const REGEX_SOLO_CEROS = /^0+$/;

// ============================================================================
// LÍMITES Y CONSTANTES DE NEGOCIO
// ============================================================================

export const LIMITES = {
  NOMBRE: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 200,
  },
  TELEFONO: {
    DIGITOS: 10,
  },
  TAMANO_GRUPO: {
    MIN: 5,
    MAX: 50,
  },
  MONTO_GRUPAL: {
    MIN: 10000,
    MAX: 100_000_000,
    MULTIPLO: 1000,
    MAX_DIGITOS: 9,
  },
  CICLOS: {
    MIN: 1,
    MAX: 99,
    MIN_CON_HISTORIAL: 2,
  },
} as const;

// ============================================================================
// MENSAJES DE ERROR
// ============================================================================

export const MENSAJES_ERROR = {
  NOMBRE: {
    REQUERIDO: 'El nombre completo es requerido',
    MIN_LENGTH: `El nombre debe tener al menos ${LIMITES.NOMBRE.MIN_LENGTH} caracteres`,
    MAX_LENGTH: `El nombre no puede exceder ${LIMITES.NOMBRE.MAX_LENGTH} caracteres`,
    SOLO_LETRAS: 'El nombre solo puede contener letras y espacios',
  },
  TELEFONO: {
    REQUERIDO: 'El teléfono es requerido',
    DIGITOS: `El teléfono debe tener ${LIMITES.TELEFONO.DIGITOS} dígitos`,
    REPETITIVO: 'El teléfono no puede ser un número repetitivo',
    SOLO_CEROS: 'El teléfono no puede ser solo ceros',
  },
  TAMANO_GRUPO: {
    RANGO: `El tamaño del grupo debe estar entre ${LIMITES.TAMANO_GRUPO.MIN} y ${LIMITES.TAMANO_GRUPO.MAX}`,
  },
  MONTO_GRUPAL: {
    REQUERIDO: 'El monto grupal es requerido',
    POSITIVO: 'El monto debe ser un número positivo',
    MIN: `El monto debe ser mayor o igual a ${LIMITES.MONTO_GRUPAL.MIN.toLocaleString('es-MX')}`,
    MAX: `El monto no puede exceder ${LIMITES.MONTO_GRUPAL.MAX.toLocaleString('es-MX')}`,
    MULTIPLO: `El monto debe ser múltiplo de ${LIMITES.MONTO_GRUPAL.MULTIPLO.toLocaleString('es-MX')}`,
  },
  FINANCIERA: {
    REQUERIDO: 'Debe seleccionar una financiera',
  },
  CICLOS: {
    MIN: 'Debe ingresar al menos 1 ciclo completado',
    MIN_CON_HISTORIAL: 'Con historial crediticio, debe tener al menos 2 ciclos completados',
  },
} as const;
